import { useMemo } from 'react';

import { Box, IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import useChangeTheme from 'hooks/useChangeTheme';

const MIN = 12; // tamanho ḿáximo da fonte
const MAX = 18; // tamanho minino da fonte
const SCALE = 2; // escala de ajuste da fonte para mais ou para menos

export default function FontResize() {
  const theme = useTheme();
  const { fontSize } = theme.typography;
  const changeTheme = useChangeTheme();

  const isMax = useMemo(() => fontSize >= MAX, [fontSize]);
  const isMin = useMemo(() => fontSize <= MIN, [fontSize]);

  const handleIncrement = () => {
    changeTheme({ type: 'CHANGE', payload: { fontSize: fontSize + SCALE } });
  };

  const handleDecrement = () => {
    changeTheme({ type: 'CHANGE', payload: { fontSize: fontSize - SCALE } });
  };

  return (
    <Box display="flex" gridGap={6} alignItems="center" justifyContent="center">
      <IconButton
        size="small"
        edge="end"
        disabled={isMax}
        onClick={handleIncrement}
      >
        <AddIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        edge="end"
        disabled={isMin}
        onClick={handleDecrement}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
